import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  planHeaderContainer: (isActive, isRecommended) => {
    return {
      borderTopLeftRadius: isRecommended ? 0 : 6,
      borderTopRightRadius: 6,
      ...(!isActive ? { borderBottomLeftRadius: 6, borderBottomRightRadius: 6 } : {}),
      height: 93.6,
      paddingHorizontal: 16.6,
      paddingTop: 17.7,
      alignSelf: 'stretch',
      flexDirection: 'row',
      alignItems: 'center',
      paddingBottom: 20.2,
    };
  },

  planNameContainer: {
    flex: 1,
    marginLeft: 14,
    marginRight: 32,
  },
  monthText: {
    fontSize: 16.6,
  },
  planNameText: {
    ...Fonts.type.bold,
    fontSize: 20.8,
  },

  planPrice: {
    ...Fonts.type.bold,
    fontSize: 20.8,
  },
  featureContainer: {
    paddingLeft: 21,
    paddingTop: 12.5,
    paddingBottom: 13.6,
    flexDirection: 'row',
    height: 51,
    alignItems: 'center',
  },

  featureIcon: {
    marginRight: 21.5,
  },

  headerIcon: {
    width: 37,
    height: 37,
  },

  priceContainer: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    marginTop: 3,
    height: 30,
  },

  dateContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 7,
  },
});
